import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createCertificateApi} from "@/api/wiser/certificate.ts";
import {defineModel} from '@jantm/model-core'
import CertificateFullListItem from "@/templates/Wiser/CertificateFullListItem.vue";
import CertificateFullDetail from "@/templates/Wiser/CertificateFullDetail.vue";
import {optionalDateSchema, optionalNumberSchema, optionalStringSchema} from "@/types/global.ts";
export const certificateSchema = z.object({
  id: z.int(),
  scheduleId: z.int(),
  courseId: z.int(),
  title: optionalStringSchema,
  naam: optionalStringSchema,
  cursist_aanhef: optionalStringSchema,
  cursist_voorletters: optionalStringSchema,
  cursist_voornaam: optionalStringSchema,
  cursist_tussenvoegsel: optionalStringSchema,
  cursist_achternaam: optionalStringSchema,
  geboortedatum: optionalStringSchema,
  geboortedatum_kort: optionalDateSchema,
  certificaatnummer: optionalStringSchema,
  cursusnaam: optionalStringSchema,
  cursuscode: optionalStringSchema,
  certificaattitel: optionalStringSchema,
  certificaatgeldigheidsduur: optionalStringSchema,
  examendatum: optionalStringSchema,
  examendatum_kort: optionalDateSchema,
  geldigtot_kort: optionalDateSchema,
})

export type Certificate = z.infer<typeof certificateSchema>

export const certificateCollectionSchema = z.array(certificateSchema)

export type CertificateCollection = z.infer<typeof certificateCollectionSchema>

export const certificateFilterSchema = z.object({
  fields: z.array(certificateSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type CertificateFilter = z.infer<typeof certificateFilterSchema>

export type CertificateFilters = {
  id?: string
  cursus?: string
  cursist_voornaam?: string
  cursist_achternaam?: string
  examendatum?: string
}

export interface CreateCertificateModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/certificates`. */
  endpoint?: string
}

export function createCertificateModel(options: CreateCertificateModelOptions) {
  return defineModel({
    name: 'Certificate',
    schema: certificateSchema,
    collectionSchema: certificateCollectionSchema,
    filterSchema: certificateFilterSchema,
    api: createCertificateApi(options.client, options.endpoint),
    identify: (certificate: Certificate) => String(certificate.id),
    templates: { FullListItem: CertificateFullListItem, FullDetail: CertificateFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type CertificateModel = ReturnType<typeof createCertificateModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Certificate: CertificateModel
  }
}
